module.exports = __webpack_public_path__ + "static/media/user-agent-light.4fff9db6.svg";